(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inviz-customer-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('inviz-stories')) return;

  class InvizStories extends HTMLElement {
    static activeGallery = null;
    static instances = new Set();
    static activePreview = null;
    static previewFrame = 0;

    connectedCallback() {
      if (this.initializationFrame || this.initialized) return;
      this.initializationFrame = requestAnimationFrame(() => {
        this.initializationFrame = 0;
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initializationFrame || 0);
      cancelAnimationFrame(this.animationFrame || 0);
      cancelAnimationFrame(this.resizeFrame || 0);
      clearTimeout(this.wakeTimer);
      this.initializationFrame = 0;
      this.animationFrame = 0;
      this.resizeFrame = 0;
      this.closeDialog(false);
      this.stopCardPreview();
      this.previewObserver?.disconnect();
      this.events?.abort();
      this.mediaEvents?.abort();
      this.intersectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.tracks?.forEach((track) => {
        clearTimeout(track.settleTimer);
        this.removeClones(track);
      });
      InvizStories.instances.delete(this);
      this.initialized = false;
      if (!InvizStories.instances.size) {
        cancelAnimationFrame(InvizStories.previewFrame);
        InvizStories.previewFrame = 0;
      } else this.requestPreviewUpdate();
    }

    initialize() {
      this.initialized = true;
      InvizStories.instances.add(this);
      this.events = new AbortController();
      this.animationFrame = 0;
      this.lastFrameTime = 0;
      this.isDialogOpen = false;
      this.keyboardMode = false;
      this.speed = this.number(this.dataset.speed, 18, 1, 120);
      this.initialCount = this.number(this.dataset.initial, 6, 1, 50);
      this.batchCount = this.number(this.dataset.batch, 6, 1, 50);
      this.scrollEnabled = this.dataset.autoplay !== 'false';
      this.previewEnabled = this.dataset.previewAutoplay !== 'false';
      this.previewFailures = new Set();
      this.dialogPlaybackToken = 0;
      this.editorMode = this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode) || document.designMode === 'on';
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.status = this.querySelector('[data-status]');
      this.dialog = this.querySelector('[data-dialog]');
      this.dialogContent = this.dialog?.querySelector('[data-dialog-content]');
      this.items = new Map();
      this.querySelectorAll('template[data-detail]').forEach((template) => {
        this.items.set(template.dataset.detail, { template });
      });
      this.tracks = Array.from(this.querySelectorAll('[data-track]')).map((element) => {
        const viewport = element.querySelector('[data-viewport]');
        const strip = element.querySelector('[data-strip]');
        if (!viewport || !strip) return null;
        const cards = Array.from(strip.children).filter((card) => card.matches('[data-card]:not([data-clone])'));
        const track = {
          element,
          viewport,
          strip,
          cards,
          expanded: element.dataset.layout === 'grid',
          shown: Math.min(cards.length, Math.floor(this.number(element.dataset.shown, this.initialCount, 1, 50))),
          clones: [],
          loop: false,
          cycle: 0,
          origin: 0,
          hovered: false,
          focused: false,
          pointerDown: false,
          inView: true,
          holdUntil: 0,
          lastWrittenPosition: null,
          lastWriteTime: 0,
          autoPosition: null,
          manual: null,
          gesture: null,
          suppressClickUntil: 0,
          editorSelected: false,
          width: 0
        };
        cards.forEach((card, index) => {
          const item = this.items.get(card.dataset.itemId);
          if (item) Object.assign(item, { card, track, cardIndex: index, id: card.dataset.itemId });
        });
        this.bindTrack(track);
        return track;
      }).filter(Boolean);
      this.bindGallery();
      this.tracks.forEach((track) => this.rebuildTrack(track));
      this.observeTracks();
      this.requestTick();
      this.requestPreviewUpdate();
    }

    number(value, fallback, minimum, maximum) {
      const parsed = Number(value);
      return Number.isFinite(parsed) && value !== undefined && value !== ''
        ? Math.min(maximum, Math.max(minimum, parsed)) : fallback;
    }

    listen(target, type, listener, options = {}) {
      target?.addEventListener(type, listener, { ...options, signal: this.events.signal });
    }

    format(template, values) {
      return (template || '').replace(/\{(count|total|index|type)\}/g, (match, key) => values[key] ?? match);
    }

    announce(message) {
      if (this.status && message) this.status.textContent = message;
    }

    bindGallery() {
      this.listen(this, 'click', (event) => {
        if (!(event.target instanceof Element)) return;
        const opener = event.target.closest('[data-open]');
        if (opener && this.contains(opener)) {
          event.preventDefault();
          const track = this.tracks.find((candidate) => candidate.element.contains(opener));
          if (track && performance.now() < track.suppressClickUntil) {
            track.suppressClickUntil = 0;
            return;
          }
          this.openDialog(opener.dataset.open, opener);
          return;
        }
      });
      this.listen(this, 'pointerdown', (event) => {
        this.keyboardMode = false;
        if (event.pointerType !== 'touch' && event.target instanceof Element && event.target.closest('[data-clone] [data-open]')) {
          event.preventDefault();
        }
      });
      this.listen(this, 'keydown', (event) => {
        this.keyboardMode = true;
        if (event.key === 'Tab') this.tracks.forEach((track) => this.updateTrackFocus(track));
      });
      this.listen(document, 'visibilitychange', () => {
        this.lastFrameTime = 0;
        if (document.hidden) {
          this.dialogPlaybackToken += 1;
          this.activeVideo?.pause();
          InvizStories.activePreview?.gallery.stopCardPreview();
          this.tracks.forEach((track) => {
            track.manual = null;
            track.pointerDown = false;
            track.gesture = null;
            track.autoPosition = null;
          });
        }
        this.requestTick();
        this.requestPreviewUpdate();
      });
      this.listen(this.motionQuery, 'change', () => {
        this.lastFrameTime = 0;
        this.requestTick();
        this.refreshPreviews();
      });
      this.listen(window, 'resize', () => this.queueResize());
      this.listen(window, 'scroll', () => this.requestPreviewUpdate(), { passive: true, capture: true });
      this.listen(document, 'shopify:block:select', (event) => this.selectEditorBlock(event));
      this.listen(document, 'shopify:block:deselect', () => {
        this.tracks.forEach((track) => { track.editorSelected = false; });
        this.requestTick();
      });
      if (!this.dialog || !this.dialogContent) return;
      this.listen(this.dialog, 'click', (event) => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-close]')) this.closeDialog();
        else if (event.target.closest('[data-dialog-prev]')) this.navigateDialog(-1);
        else if (event.target.closest('[data-dialog-next]')) this.navigateDialog(1);
        else if (event.target.closest('[data-retry]')) {
          if (this.setCurrentMedia(this.activeMediaId, true)) this.startVideo();
        }
        else if (event.target.closest('[data-thumb]')) {
          const thumb = event.target.closest('[data-thumb]');
          if (!thumb.disabled && this.setCurrentMedia(thumb.dataset.thumb)) this.startVideo();
        }
        else if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            this.closeDialog();
          }
        }
      });
      this.listen(this.dialog, 'cancel', (event) => {
        event.preventDefault();
        this.closeDialog();
      });
      this.listen(this.dialog, 'close', () => {
        if (!this.dialog.open && this.isDialogOpen) this.closeDialog();
      });
      this.listen(this.dialog, 'keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.target instanceof Element && event.target.closest('video, input, textarea, select, [contenteditable="true"], [data-related-products]')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.navigateDialog(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.listen(this.dialogContent, 'pointerdown', (event) => {
        this.swipe = null;
        if (event.pointerType !== 'touch' || !event.isPrimary || !(event.target instanceof Element)) return;
        if (event.target.closest('a, button, input, textarea, select, video, [data-related-products]')) return;
        const media = event.target.closest('[data-media-slot] [data-media]');
        if (media && media.querySelector('img') && !media.querySelector('video')) {
          this.swipe = { x: event.clientX, y: event.clientY, pointerId: event.pointerId };
        }
      }, { passive: true });
      this.listen(this.dialogContent, 'pointerup', (event) => {
        const start = this.swipe;
        this.swipe = null;
        if (!start || start.pointerId !== event.pointerId) return;
        const horizontal = event.clientX - start.x;
        const vertical = event.clientY - start.y;
        if (Math.abs(horizontal) > 50 && Math.abs(horizontal) > Math.abs(vertical) * 1.4) {
          this.navigateDialog(horizontal < 0 ? 1 : -1);
        }
      }, { passive: true });
      this.listen(this.dialogContent, 'pointercancel', () => { this.swipe = null; }, { passive: true });
    }

    bindTrack(track) {
      const { element, viewport } = track;
      this.listen(element, 'pointerenter', (event) => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
          track.hovered = true;
          this.requestTick();
        }
      });
      this.listen(element, 'pointerleave', () => {
        track.hovered = false;
        this.requestTick();
      });
      this.listen(element, 'focusin', () => {
        const active = document.activeElement;
        if (active instanceof Element && active.closest('[data-clone]')) {
          const id = active.closest('[data-open]')?.dataset.open;
          const original = track.cards.find((card) => card.dataset.itemId === id)?.querySelector('[data-open]');
          original?.focus({ preventScroll: true });
        }
        this.updateTrackFocus(track);
      });
      this.listen(element, 'focusout', () => queueMicrotask(() => {
        if (this.isConnected) this.updateTrackFocus(track);
      }));
      this.listen(viewport, 'pointerdown', (event) => {
        if (track.expanded || !event.isPrimary || event.button !== 0) return;
        track.pointerDown = true;
        track.manual = null;
        track.autoPosition = null;
        track.suppressClickUntil = 0;
        track.gesture = { x: event.clientX, y: event.clientY, pointerId: event.pointerId, moved: false };
        this.requestTick();
      }, { passive: true });
      this.listen(window, 'pointermove', (event) => {
        if (track.expanded || !track.gesture || track.gesture.pointerId !== event.pointerId) return;
        if (Math.hypot(event.clientX - track.gesture.x, event.clientY - track.gesture.y) > 8) track.gesture.moved = true;
      }, { passive: true });
      const releasePointer = (event) => {
        if (track.expanded || !track.pointerDown) return;
        if (track.gesture && track.gesture.pointerId !== event.pointerId) return;
        if (track.gesture?.moved || event.type === 'pointercancel') track.suppressClickUntil = performance.now() + 450;
        track.pointerDown = false;
        track.gesture = null;
        track.holdUntil = performance.now() + 1200;
        this.settleTrack(track);
        this.requestTick();
      };
      this.listen(window, 'pointerup', releasePointer, { passive: true });
      this.listen(window, 'pointercancel', releasePointer, { passive: true });
      this.listen(viewport, 'wheel', () => {
        if (track.expanded) return;
        track.manual = null;
        track.autoPosition = null;
        track.holdUntil = performance.now() + 1200;
        this.requestTick();
      }, { passive: true });
      this.listen(viewport, 'scroll', () => {
        if (track.expanded) {
          this.requestPreviewUpdate();
          return;
        }
        const now = performance.now();
        const ownScroll = track.lastWrittenPosition !== null
          && Math.abs(viewport.scrollLeft - track.lastWrittenPosition) < 1.5
          && now - track.lastWriteTime < 160;
        if (!ownScroll && !track.manual) {
          track.holdUntil = now + 1000;
          track.autoPosition = null;
          this.settleTrack(track);
        }
        this.updateArrows(track);
        this.requestPreviewUpdate();
        if (!ownScroll) this.requestTick();
      }, { passive: true });
      this.listen(element, 'click', (event) => {
        if (!(event.target instanceof Element)) return;
        const scrollButton = event.target.closest('[data-scroll]');
        if (scrollButton) this.scrollTrack(track, scrollButton.dataset.scroll === 'prev' ? -1 : 1);
        if (event.target.closest('[data-more]')) this.loadMore(track);
      });
    }

    updateTrackFocus(track) {
      const active = document.activeElement;
      track.focused = Boolean(active && track.element.contains(active)
        && (this.keyboardMode || active.matches(':focus-visible')));
      this.requestTick();
    }

    settleTrack(track) {
      clearTimeout(track.settleTimer);
      if (track.expanded) return;
      track.settleTimer = setTimeout(() => {
        if (!this.isConnected || track.expanded || track.pointerDown || track.manual) return;
        this.normalizeTrack(track);
        this.requestTick();
      }, 160);
    }

    observeTracks() {
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const track = this.tracks.find((candidate) => candidate.viewport === entry.target);
            if (track) track.inView = entry.isIntersecting;
          });
          this.requestTick();
          this.requestPreviewUpdate();
        }, { threshold: 0.01 });
        this.tracks.forEach((track) => this.intersectionObserver.observe(track.viewport));
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queueResize());
        this.tracks.forEach((track) => this.resizeObserver.observe(track.viewport));
      }
    }

    queueResize() {
      if (this.resizeFrame || !this.isConnected) return;
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = 0;
        this.tracks.forEach((track) => {
          if (Math.abs(track.width - track.viewport.clientWidth) > 0.5) this.rebuildTrack(track);
        });
        this.requestTick();
      });
    }

    removeClones(track) {
      if (InvizStories.activePreview?.gallery === this && track.clones.includes(InvizStories.activePreview.card)) this.stopCardPreview();
      track.clones.forEach((clone) => clone.remove());
      track.clones = [];
    }

    cloneCard(card) {
      const clone = card.cloneNode(true);
      clone.querySelectorAll('video[data-card-preview]').forEach((video) => video.remove());
      clone.dataset.previewPlaying = 'false';
      clone.dataset.clone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('hidden');
      [clone, ...clone.querySelectorAll('*')].forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')
            || ['aria-labelledby', 'aria-describedby', 'aria-controls', 'for'].includes(attribute.name)) {
            element.removeAttribute(attribute.name);
          }
        });
        if (element.matches('a, button, input, select, textarea, summary, [tabindex], [contenteditable], audio, video')) {
          element.setAttribute('tabindex', '-1');
          element.removeAttribute('autofocus');
        }
      });
      return clone;
    }

    rebuildTrack(track) {
      if (InvizStories.activePreview?.gallery === this && InvizStories.activePreview.track === track) this.stopCardPreview();
      const previousOffset = track.expanded ? 0 : track.loop
        ? ((track.viewport.scrollLeft - track.origin) % track.cycle + track.cycle) % track.cycle
        : track.viewport.scrollLeft;
      track.manual = null;
      clearTimeout(track.settleTimer);
      track.settleTimer = null;
      this.removeClones(track);
      track.cards.forEach((card, index) => { card.hidden = index >= track.shown; });
      track.element.dataset.shown = String(track.shown);
      const visible = track.cards.slice(0, track.shown);
      track.width = track.viewport.clientWidth;
      track.loop = false;
      track.cycle = 0;
      track.origin = 0;
      if (track.expanded) {
        track.autoPosition = null;
        track.pointerDown = false;
        track.gesture = null;
        track.holdUntil = 0;
        track.suppressClickUntil = 0;
        track.lastWrittenPosition = null;
        track.lastWriteTime = 0;
        track.viewport.removeAttribute('tabindex');
      }
      const first = visible[0];
      const last = visible[visible.length - 1];
      if (!track.expanded && first && last && track.width > 0
        && (!this.editorMode || this.dataset.motionInEditor !== 'false')) {
        const contentWidth = last.getBoundingClientRect().right - first.getBoundingClientRect().left;
        if (visible.length > 1 && contentWidth > track.width + 1) {
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          visible.forEach((card) => {
            const leading = this.cloneCard(card);
            const trailing = this.cloneCard(card);
            before.append(leading);
            after.append(trailing);
            track.clones.push(leading, trailing);
          });
          track.strip.prepend(before);
          track.strip.append(after);
          const originalRect = first.getBoundingClientRect();
          const leadingRect = track.strip.firstElementChild.getBoundingClientRect();
          track.cycle = originalRect.left - leadingRect.left;
          track.origin = originalRect.left - track.viewport.getBoundingClientRect().left + track.viewport.scrollLeft;
          track.loop = track.cycle > 0;
        }
      }
      this.writeScroll(track, track.loop ? track.origin + previousOffset % track.cycle : previousOffset);
      const more = track.element.querySelector('[data-more]');
      if (more) more.hidden = track.shown >= track.cards.length;
      const count = track.element.querySelector('[data-count]');
      if (count) count.textContent = this.loadedMessage(track);
      this.updateArrows(track);
      track.previewCards = Array.from(track.strip.children).filter((card) => !card.hidden && card.querySelector('template[data-card-video]'));
      this.observePreviewCards();
      this.requestPreviewUpdate();
    }

    loadedMessage(track) {
      return this.format(this.dataset.loadedLabel, {
        count: track.shown,
        total: track.cards.length,
        type: track.element.dataset.label || ''
      });
    }

    loadMore(track) {
      if (track.shown >= track.cards.length) return;
      const firstNewIndex = track.shown;
      const more = track.element.querySelector('[data-more]');
      const restoreMoreFocus = document.activeElement === more;
      track.expanded = true;
      track.element.dataset.layout = 'grid';
      track.shown = Math.min(track.cards.length, track.shown + this.batchCount);
      this.rebuildTrack(track);
      const card = track.cards[firstNewIndex];
      if (more?.hidden && restoreMoreFocus) card?.querySelector('[data-open]')?.focus({ preventScroll: true });
      this.announce(this.loadedMessage(track));
      this.requestTick();
    }

    revealCard(track, card) {
      if (track.expanded) return;
      const offset = card.getBoundingClientRect().left - track.viewport.getBoundingClientRect().left + track.viewport.scrollLeft;
      this.writeScroll(track, offset);
      this.normalizeTrack(track);
    }

    selectEditorBlock(event) {
      const id = String(event.detail?.blockId || '');
      let item = this.items.get(id);
      if (!item?.track || !item.card) {
        for (const track of this.tracks) {
          const cardIndex = track.cards.findIndex((card) => card.dataset.itemId === id);
          if (cardIndex >= 0) {
            item = { track, card: track.cards[cardIndex], cardIndex };
            break;
          }
        }
      }
      if (!item?.track || !item.card) return;
      this.closeDialog(false);
      const track = item.track;
      track.editorSelected = true;
      if (item.cardIndex >= track.shown) {
        track.shown = Math.min(track.cards.length,
          this.initialCount + Math.ceil((item.cardIndex + 1 - this.initialCount) / this.batchCount) * this.batchCount);
        this.rebuildTrack(track);
      }
      this.revealCard(track, item.card);
      item.card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      this.requestTick();
    }

    writeScroll(track, position, autoplay = false) {
      if (!autoplay) track.autoPosition = null;
      track.viewport.scrollLeft = track.expanded ? 0 : position;
      track.lastWrittenPosition = track.viewport.scrollLeft;
      track.lastWriteTime = performance.now();
      this.requestPreviewUpdate();
    }

    normalizeTrack(track) {
      if (track.expanded || !track.loop || !track.cycle) return;
      const position = track.viewport.scrollLeft;
      if (position < track.origin - 1 || position >= track.origin + track.cycle) {
        this.writeScroll(track, track.origin + ((position - track.origin) % track.cycle + track.cycle) % track.cycle);
      }
    }

    updateArrows(track) {
      const previous = track.element.querySelector('[data-scroll="prev"]');
      const next = track.element.querySelector('[data-scroll="next"]');
      const actions = track.element.querySelector('.ig-track-actions');
      const header = track.element.querySelector('.ig-track-header');
      if (actions) actions.hidden = track.expanded;
      if (header) header.hidden = track.expanded && !header.querySelector('[data-stories-heading]');
      if (previous) {
        previous.hidden = track.expanded;
        previous.disabled = track.expanded || (!track.loop && track.viewport.scrollLeft <= 1);
      }
      if (next) {
        next.hidden = track.expanded;
        next.disabled = track.expanded || (!track.loop && track.viewport.scrollLeft >= track.viewport.scrollWidth - track.viewport.clientWidth - 1);
      }
    }

    scrollTrack(track, direction) {
      if (track.expanded) return;
      const first = track.cards[0];
      if (!first) return;
      const gap = parseFloat(getComputedStyle(track.strip).columnGap) || 0;
      const distance = direction * (first.getBoundingClientRect().width + gap);
      track.holdUntil = performance.now() + 1500;
      if (this.motionQuery.matches && this.dataset.respectReducedMotion !== 'false') {
        this.writeScroll(track, track.viewport.scrollLeft + distance);
        this.normalizeTrack(track);
        this.updateArrows(track);
      } else {
        track.manual = { distance, applied: 0, start: performance.now(), duration: 360 };
      }
      this.requestTick();
    }

    observePreviewCards() {
      this.previewObserver?.disconnect();
      if (!this.previewEnabled || !('IntersectionObserver' in window)) return;
      if (!this.previewObserver) {
        this.previewObserver = new IntersectionObserver(() => this.requestPreviewUpdate(), { threshold: [0, 0.5, 1] });
      }
      this.tracks?.forEach((track) => track.previewCards?.forEach((card) => {
        const button = card.querySelector('.ig-media-button');
        if (button) this.previewObserver.observe(button);
      }));
    }

    motionAllowed() {
      return (!this.editorMode || this.dataset.motionInEditor !== 'false')
        && !(this.motionQuery.matches && this.dataset.respectReducedMotion !== 'false');
    }

    canPreview() {
      return this.isConnected && this.initialized && this.previewEnabled && this.dataset.previewAutoplay !== 'false'
        && this.motionAllowed() && !document.hidden && !InvizStories.activeGallery;
    }

    previewVisibility(card, track) {
      if (!card.isConnected || card.hidden || !track.inView) return 0;
      const media = card.querySelector('.ig-media-button');
      if (!media) return 0;
      const bounds = media.getBoundingClientRect();
      const viewport = track.viewport.getBoundingClientRect();
      if (!bounds.width || !bounds.height || !viewport.width || !viewport.height) return 0;
      const width = Math.max(0, Math.min(bounds.right, viewport.right, window.innerWidth || document.documentElement.clientWidth)
        - Math.max(bounds.left, viewport.left, 0));
      const height = Math.max(0, Math.min(bounds.bottom, viewport.bottom, window.innerHeight || document.documentElement.clientHeight)
        - Math.max(bounds.top, viewport.top, 0));
      return width * height / (bounds.width * bounds.height);
    }

    requestPreviewUpdate() {
      if (InvizStories.previewFrame) return;
      InvizStories.previewFrame = requestAnimationFrame(() => {
        InvizStories.previewFrame = 0;
        this.refreshPreviews();
      });
    }

    refreshPreviews() {
      const current = InvizStories.activePreview;
      if (current && current.gallery.canPreview() && current.gallery.previewVisibility(current.card, current.track) >= 0.5) return;
      if (current) current.gallery.stopCardPreview();
      let candidate = null;
      InvizStories.instances.forEach((gallery) => {
        if (!gallery.canPreview()) return;
        gallery.tracks.forEach((track) => {
          track.previewCards?.forEach((card) => {
            if (gallery.previewFailures.has(card.dataset.itemId)) return;
            const ratio = gallery.previewVisibility(card, track);
            if (ratio >= 0.5 && (!candidate || ratio > candidate.ratio)) candidate = { gallery, card, track, ratio };
          });
        });
      });
      if (candidate) candidate.gallery.startCardPreview(candidate.card, candidate.track);
    }

    forcePreviewMuted(video) {
      if (!video.defaultMuted) video.defaultMuted = true;
      if (!video.muted) video.muted = true;
      if (video.volume !== 0) video.volume = 0;
      video.controls = false;
      video.playsInline = true;
    }

    startCardPreview(card, track) {
      if (!this.canPreview() || this.previewVisibility(card, track) < 0.5) return;
      const template = card.querySelector('template[data-card-video]');
      const button = card.querySelector('.ig-media-button');
      const video = template?.content.querySelector('video')?.cloneNode(true);
      if (!video || !button) return;
      InvizStories.activePreview?.gallery.stopCardPreview();
      const events = new AbortController();
      const preview = { gallery: this, card, track, video, events };
      InvizStories.activePreview = preview;
      card.dataset.previewPlaying = 'false';
      video.dataset.cardPreview = '';
      video.removeAttribute('id');
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.loop = true;
      video.preload = 'none';
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      video.disablePictureInPicture = true;
      this.forcePreviewMuted(video);
      const stillCurrent = () => InvizStories.activePreview === preview && this.canPreview()
        && this.previewVisibility(card, track) >= 0.5;
      const rejectPreview = () => {
        if (InvizStories.activePreview !== preview) {
          video.pause();
          return;
        }
        if (this.canPreview() && this.previewVisibility(card, track) >= 0.5) this.previewFailures.add(card.dataset.itemId);
        this.stopCardPreview();
        this.requestPreviewUpdate();
      };
      const confirmPlayback = () => {
        if (!stillCurrent()) {
          if (InvizStories.activePreview === preview) this.stopCardPreview();
          else video.pause();
          return;
        }
        this.forcePreviewMuted(video);
        card.dataset.previewPlaying = 'true';
      };
      video.addEventListener('volumechange', () => this.forcePreviewMuted(video), { signal: events.signal });
      video.addEventListener('play', () => {
        this.forcePreviewMuted(video);
        if (!stillCurrent()) {
          if (InvizStories.activePreview === preview) this.stopCardPreview();
          else video.pause();
        }
      }, { signal: events.signal });
      video.addEventListener('playing', confirmPlayback, { signal: events.signal });
      video.addEventListener('pause', rejectPreview, { signal: events.signal });
      video.addEventListener('error', rejectPreview, { signal: events.signal });
      button.append(video);
      try {
        const promise = video.play();
        if (promise?.then) promise.then(confirmPlayback).catch(rejectPreview);
      } catch (_) { rejectPreview(); }
    }

    stopCardPreview() {
      const preview = InvizStories.activePreview;
      if (!preview || preview.gallery !== this) return;
      InvizStories.activePreview = null;
      preview.events.abort();
      preview.card.dataset.previewPlaying = 'false';
      preview.video.pause();
      preview.video.removeAttribute('src');
      preview.video.querySelectorAll('source, track').forEach((source) => source.removeAttribute('src'));
      preview.video.load();
      preview.video.remove();
    }

    canAutoplay(track) {
      return this.isConnected && this.initialized && !track.expanded && this.scrollEnabled
        && this.dataset.autoplay !== 'false' && this.motionAllowed()
        && !document.hidden && !InvizStories.activeGallery && track.loop && track.inView
        && !track.hovered && !track.focused && !track.pointerDown && !track.editorSelected;
    }

    requestTick() {
      if (!this.isConnected || !this.initialized || this.animationFrame) return;
      clearTimeout(this.wakeTimer);
      this.animationFrame = requestAnimationFrame((timestamp) => this.tick(timestamp));
    }

    tick(timestamp) {
      this.animationFrame = 0;
      if (!this.isConnected) return;
      const delta = this.lastFrameTime ? Math.min((timestamp - this.lastFrameTime) / 1000, 0.064) : 0;
      this.lastFrameTime = timestamp;
      let continueAnimation = false;
      let wakeAt = Infinity;
      this.tracks.forEach((track) => {
        if (track.expanded) return;
        if (track.manual && !document.hidden && !InvizStories.activeGallery) {
          const progress = Math.min(1, (timestamp - track.manual.start) / track.manual.duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          const applied = track.manual.distance * eased;
          this.writeScroll(track, track.viewport.scrollLeft + applied - track.manual.applied);
          this.normalizeTrack(track);
          track.manual.applied = applied;
          this.updateArrows(track);
          if (progress >= 1) {
            track.manual = null;
            track.holdUntil = timestamp + 1000;
            if (this.canAutoplay(track)) wakeAt = Math.min(wakeAt, track.holdUntil);
          } else continueAnimation = true;
        } else if (this.canAutoplay(track)) {
          if (timestamp < track.holdUntil) wakeAt = Math.min(wakeAt, track.holdUntil);
          else {
            if (delta) {
              if (track.autoPosition === null) track.autoPosition = track.viewport.scrollLeft;
              track.autoPosition += this.speed * delta;
              if (track.autoPosition >= track.origin + track.cycle) track.autoPosition -= track.cycle;
              this.writeScroll(track, track.autoPosition, true);
              this.normalizeTrack(track);
            }
            continueAnimation = true;
          }
        }
      });
      if (continueAnimation) this.animationFrame = requestAnimationFrame((next) => this.tick(next));
      else {
        this.lastFrameTime = 0;
        if (Number.isFinite(wakeAt)) {
          this.wakeTimer = setTimeout(() => this.requestTick(), Math.max(20, wakeAt - performance.now() + 20));
        }
      }
    }

    openDialog(id, opener) {
      const item = this.items.get(id);
      if (!item || !this.dialog || !this.dialogContent) return;
      const story = item.template.content.cloneNode(true);
      const mediaTemplates = Array.from(story.querySelectorAll('template[data-media-item]'));
      const mediaItems = new Map();
      mediaTemplates.forEach((template) => {
        const mediaId = template.dataset.mediaItem;
        if (mediaId && template.content.querySelector('[data-media]') && !mediaItems.has(mediaId)) {
          mediaItems.set(mediaId, template);
        }
      });
      if (!mediaItems.size || !story.querySelector('[data-media-slot]')) return;
      if (InvizStories.activeGallery && InvizStories.activeGallery !== this) InvizStories.activeGallery.closeDialog(false);
      this.returnFocus = opener?.closest('[data-clone]') ? item.card?.querySelector('[data-open]') : opener || document.activeElement;
      this.returnItemId = id;
      if (!this.isDialogOpen) {
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.isDialogOpen = true;
        InvizStories.activeGallery = this;
        InvizStories.instances.forEach((gallery) => {
          gallery.tracks.forEach((track) => { track.manual = null; });
          gallery.lastFrameTime = 0;
          gallery.requestTick();
        });
      }
      InvizStories.activePreview?.gallery.stopCardPreview();
      this.stopVideo();
      this.activeStoryId = id;
      this.activeMediaId = null;
      this.mediaItems = mediaItems;
      this.mediaOrder = Array.from(mediaItems.keys());
      this.dialogContent.replaceChildren(story);
      this.mediaSlot = this.dialogContent.querySelector('[data-media-slot]');
      this.mediaCaption = this.dialogContent.querySelector('[data-media-caption]');
      const startId = item.template.dataset.startId;
      if (!this.dialog.open) this.dialog.showModal();
      this.setCurrentMedia(this.mediaItems.has(startId) ? startId : this.mediaOrder[0]);
      const scroller = this.dialogContent.closest('[data-dialog-scroll], .is-dialog-scroll, .ig-dialog-scroll') || this.dialogContent;
      scroller.scrollTop = 0;
      this.dialog.querySelector('[data-close]')?.focus({ preventScroll: true });
      this.startVideo();
      this.requestTick();
    }

    stopVideo() {
      this.dialogPlaybackToken = (this.dialogPlaybackToken || 0) + 1;
      this.mediaEvents?.abort();
      this.mediaEvents = null;
      this.mediaSlot?.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        video.querySelectorAll('track').forEach((track) => track.removeAttribute('src'));
        video.load();
      });
      this.activeVideo = null;
    }

    setCurrentMedia(id, retry = false) {
      if (!this.isDialogOpen || !this.mediaSlot || !this.mediaItems?.has(id) || (id === this.activeMediaId && !retry)) return false;
      const fragment = this.mediaItems.get(id).content.cloneNode(true);
      const media = fragment.querySelector('[data-media]');
      if (!media) return false;
      this.stopVideo();
      this.swipe = null;
      this.activeMediaId = id;
      this.mediaEvents = new AbortController();
      this.activeVideo = media.querySelector('video');
      const captions = fragment.querySelector('template[data-captions]');
      if (captions && this.activeVideo) {
        this.activeVideo.crossOrigin = 'anonymous';
        const tracks = captions.content.cloneNode(true);
        tracks.querySelectorAll('track').forEach((track) => track.removeAttribute('default'));
        this.activeVideo.append(tracks);
        captions.remove();
      }
      const itemCaption = fragment.querySelector('[data-item-caption]');
      this.mediaSlot.replaceChildren(media);
      if (this.mediaCaption) {
        this.mediaCaption.replaceChildren(...(itemCaption ? Array.from(itemCaption.childNodes) : []));
        this.mediaCaption.hidden = !this.mediaCaption.textContent.trim();
      }
      const showError = () => {
        if (!this.dataset.mediaErrorLabel || media.querySelector('[data-media-error]')) return;
        const message = document.createElement('p');
        message.className = 'is-media-error ig-media-error';
        message.dataset.mediaError = '';
        message.setAttribute('role', 'status');
        message.textContent = this.dataset.mediaErrorLabel;
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.dataset.retry = '';
        retry.className = 'is-media-retry';
        retry.textContent = this.dataset.retryLabel || 'Retry';
        message.append(document.createTextNode(' '), retry);
        media.append(message);
      };
      media.querySelectorAll('img, video').forEach((element) => {
        element.addEventListener('error', showError, { signal: this.mediaEvents.signal, once: true });
        if (element instanceof HTMLImageElement && element.complete && !element.naturalWidth) showError();
      });
      if (this.activeVideo) {
        this.activeVideo.controls = true;
        this.activeVideo.playsInline = true;
        this.activeVideo.preload = 'metadata';
        this.activeVideo.autoplay = false;
        this.activeVideo.defaultMuted = this.dataset.dialogMuted === 'true';
        this.activeVideo.muted = this.dataset.dialogMuted === 'true';
      }
      this.updateMediaNavigation();
      return true;
    }

    updateMediaNavigation() {
      const index = this.mediaOrder.indexOf(this.activeMediaId);
      const total = this.mediaOrder.length;
      const values = { count: index + 1, index: index + 1, total };
      this.dialog.querySelectorAll('[data-dialog-count], [data-dialog-position]').forEach((position) => {
        position.setAttribute('aria-live', 'polite');
        position.setAttribute('aria-atomic', 'true');
        position.textContent = this.format(this.dataset.positionString || '{index} / {total}', values);
      });
      this.dialog.querySelectorAll('[data-dialog-prev]').forEach((button) => { button.disabled = index <= 0; });
      this.dialog.querySelectorAll('[data-dialog-next]').forEach((button) => { button.disabled = index >= total - 1; });
      this.dialog.querySelectorAll('[data-media-navigation], [data-thumbnails]').forEach((element) => {
        element.hidden = total < 2;
      });
      this.dialog.querySelectorAll('[data-thumb]').forEach((button) => {
        const selected = button.dataset.thumb === this.activeMediaId;
        button.dataset.active = String(selected);
        button.classList.toggle('is-active', selected);
        if (selected) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
        button.disabled = !this.mediaItems.has(button.dataset.thumb);
        button.hidden = button.disabled;
        if (selected) {
          const thumbnails = button.closest('[data-thumbnails]');
          if (thumbnails && !thumbnails.hidden) {
            const buttonBounds = button.getBoundingClientRect();
            const stripBounds = thumbnails.getBoundingClientRect();
            if (buttonBounds.left < stripBounds.left) thumbnails.scrollLeft -= stripBounds.left - buttonBounds.left;
            else if (buttonBounds.right > stripBounds.right) thumbnails.scrollLeft += buttonBounds.right - stripBounds.right;
          }
        }
      });
      this.announce(this.format(this.dataset.itemLabel || this.dataset.positionString, values));
    }

    startVideo() {
      if (!this.activeVideo || !this.isDialogOpen || document.hidden || this.dataset.dialogAutoplay === 'false') return;
      const video = this.activeVideo;
      const token = ++this.dialogPlaybackToken;
      try {
        const promise = video.play();
        if (promise?.then) promise.then(() => {
          if (this.activeVideo !== video || this.dialogPlaybackToken !== token || !this.isDialogOpen || document.hidden) video.pause();
        }).catch(() => {});
      } catch (_) {}
    }

    navigateDialog(direction) {
      if (!this.isDialogOpen || this.mediaOrder?.length < 2) return;
      const current = this.mediaOrder.indexOf(this.activeMediaId);
      const next = current + direction;
      if (current < 0 || next < 0 || next >= this.mediaOrder.length) return;
      if (this.setCurrentMedia(this.mediaOrder[next])) this.startVideo();
    }

    closeDialog(restoreFocus = true) {
      if (!this.isDialogOpen) return;
      this.isDialogOpen = false;
      this.stopVideo();
      this.dialogContent?.replaceChildren();
      this.activeStoryId = null;
      this.activeMediaId = null;
      this.mediaItems = null;
      this.mediaOrder = [];
      this.mediaSlot = null;
      this.mediaCaption = null;
      if (this.dialog?.open) this.dialog.close();
      if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
      this.swipe = null;
      if (InvizStories.activeGallery === this) InvizStories.activeGallery = null;
      InvizStories.instances.forEach((gallery) => gallery.requestTick());
      this.requestPreviewUpdate();
      const focusTarget = this.returnFocus;
      this.returnFocus = null;
      if (restoreFocus && focusTarget?.isConnected) {
        queueMicrotask(() => {
          if (!this.isConnected || this.isDialogOpen || InvizStories.activeGallery) return;
          focusTarget.focus({ preventScroll: true });
          const item = this.items.get(this.returnItemId);
          if (item?.card && item.track) {
            const cardBounds = item.card.getBoundingClientRect();
            const viewportBounds = item.track.viewport.getBoundingClientRect();
            if (cardBounds.left < viewportBounds.left || cardBounds.right > viewportBounds.right) this.revealCard(item.track, item.card);
          }
        });
      }
      this.requestTick();
    }
  }

  customElements.define('inviz-stories', InvizStories);
})();


  } catch(e) { console.error(e); }
})();
})();
